import React from "react";

const ProjectHealthScore = ({ metrics }) => {

  const score =
    (
      metrics.sprintCompletion * 0.25 +
      metrics.velocityStability * 0.20 +
      metrics.bugSeverity * 0.20 +
      metrics.cycleTime * 0.20 +
      metrics.teamLoad * 0.15
    ).toFixed(0);

  const color =
    score > 80
      ? "text-green-400"
      : score > 60
      ? "text-yellow-400"
      : "text-red-400";

  return (
    <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">

      <h3 className="text-white font-semibold mb-3">
        💡 Project Health Score
      </h3>

      <div className={`text-4xl font-bold ${color}`}>
        {score}%
      </div>

      <div className="text-xs text-gray-400 mt-2">
        Based on sprint completion, velocity stability, bug severity,
        cycle time and team load
      </div>

    </div>
  );
};

export default ProjectHealthScore;